var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.07243 1.38965e-06L6.14564 1.06747L2.90576 4.3001L13 4.3001L13 5.8006L2.89564 5.81068L6.05452 8.9426L4.98131 10L8.83409e-07 5.06546L5.07243 1.38965e-06Z"}));
}

Arrow.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10"};

module.exports = Arrow;

Arrow.default = Arrow;
